import { createRouter, createWebHistory } from 'vue-router';
import EpkChapterPage from '@/page/EpkChapterPage/EpkChapterPage.vue';
import MainPage from '@/page/MainPage/MainPage.vue';

const routes = [
	{
		path: '/',
		name: 'MainPage',
		component: MainPage,
	},
	{
		path: '/:page',
		name: 'ChapterPage',
		component: EpkChapterPage,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
